export class Game {
  constructor(obj) {
    this.gameId = obj.gameId;
  }
  static from(data) {
    return new Game({
      gameId: data,
    });
  }
  static fromAll(data) {
    if (!data) return [];
    return data.map(item => {
      return Game.from(item);
    });
  }
}
